/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';

/**
 * 
 * @export
 * @interface GetInsuredsResponseDto
 */
export interface GetInsuredsResponseDto {
    /**
     * Liste des assures (personnes physiques ou morales)
     * @type {Array<PersonDto>}
     * @memberof GetInsuredsResponseDto
     */
    insureds?: Array<PersonDto>;
}

/**
 * Check if a given object implements the GetInsuredsResponseDto interface.
 */
export function instanceOfGetInsuredsResponseDto(value: object): value is GetInsuredsResponseDto {
    return true;
}

export function GetInsuredsResponseDtoFromJSON(json: any): GetInsuredsResponseDto {
    return GetInsuredsResponseDtoFromJSONTyped(json, false);
}

export function GetInsuredsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInsuredsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insureds': json['insureds'] == null ? undefined : ((json['insureds'] as Array<any>).map(PersonDtoFromJSON)),
    };
}

export function GetInsuredsResponseDtoToJSON(json: any): GetInsuredsResponseDto {
    return GetInsuredsResponseDtoToJSONTyped(json, false);
}

export function GetInsuredsResponseDtoToJSONTyped(value?: GetInsuredsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insureds': value['insureds'] == null ? undefined : ((value['insureds'] as Array<any>).map(PersonDtoToJSON)),
    };
}

